import { signOut } from "aws-amplify/auth";

import { axiosClient } from "@/lib/axios";
import { queryClient } from "@/lib/react-query";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const logout = async (): Promise<void> => {
  await signOut({ global: true });
  delete axiosClient.defaults.headers.common.Authorization;

  queryClient.setQueryData(["user"], null);
  queryClient.clear();
};

function useLogout(mutationOptions?: UseMutationOptions<void>) {
  return useMutation({
    mutationFn: logout,
    ...mutationOptions,
  });
}

export { useLogout };
